module.exports = "<div class=\"alert alert--info\" ng-if=\"!$ctrl.response\">\n    <p >Attempting to connect your Stripe account!</p>\n</div>\n\n<div ng-if=\"$ctrl.response\" class=\"alert alert--success\" ng-class=\"{ 'alert--fail' : $ctrl.error }\">\n    <p ng-bind=\"$ctrl.response\"></p>\n</div>\n\n<div class=\"row align-center\">\n    <a class=\"button button--large round\" ui-sref=\"app.admin.property-edit({property: $ctrl.id})\">Return to Property</a>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/property/views/payment.connect.html
// module id = 547
// module chunks = 0